export const ROLES = ["VIEWER", "AGENT", "ADMIN"];

export const ROLE_BADGE_VARIANT = {
  ADMIN: "info",
  AGENT: "warning",
  VIEWER: "preparing",
};

export function extractErrorMessage(err, fallback) {
  const errors = err?.response?.data?.errors;
  if (errors && typeof errors === "object") {
    for (const group of Object.values(errors)) {
      if (group && typeof group === "object") {
        const first = Object.values(group)[0];
        if (typeof first === "string") return first;
      }
    }
  }
  const message = err?.response?.data?.message;
  if (typeof message === "string") return message;
  if (Array.isArray(message) && typeof message[0] === "string") return message[0];
  return fallback;
}
